export default {
  title: '황준필♥︎한희송 2019.04.13 오후 3시 그랜드 힐 컨벤션',
  husband: ['황', '준필'],
  wife: ['한', '희송'],
  date: '2019년 4월 13일 토요일 오후 3시',
  location: '그랜드 힐 컨벤션 1층 플로리아',
  locations: {
    address: '주소',
    addressContent: '서울특별시 강남구 대치2동 역삼로 607, <br /> <strong>그랜드 힐 컨벤션</strong>',
    subway: '지하철',
    subwayContent: '2호선 삼성역 1번 출구 셔틀버스 이용 혹은, <br />2번 출구에서 도보 5분 소요',
    bus: '버스',
    busContent: '간선버스 143, 146, 341, 360, 401 <br />지선버스 2413, 3411, 3422, 4318, 4419, 917, 11-3 <br />광역버스 9407, 6900',
  },
  invite: '님',
  greeting: [
    '반짝이는 4월의 어느 날,', 
    '모두의 앞에서 두 손을 맞잡으며', 
    '한 길을 같이 할 것을 약속하고자 합니다.', 
    '이 마음 변치 않고 걸을 수 있도록,', 
    '많은 격려와 축복 부탁드립니다.'],
  telWho: ['신랑에게', '신부에게'],
  money: '축의금',
  moneySend: '축의금 보내기',
  tossAppSet: '토스 앱 설치하기',
  deposit: '입금주소',
  copy: '주소 복사',
  huobi: '후오비 거래소 바로가기'
};


// WEBPACK FOOTER //
// ./src/locales/ko-KR/home.ts